import React from "react";
import { FaHome } from "react-icons/fa";
import aboutImg1 from "../assets/images/about-img.jpg"; // replace with real image
import aboutImg2 from "../assets/images/about-img-2.jpg"; // replace with real image
import breadcumbBG from "../assets/images/Banner_BG.jpg"; // replace with real image
import ServiceSection from "../components/ServiceSection";
import DownloadAppBanner from "../components/DownloadAppBanner";
import Breadcrumb from "../components/Breadcrumb";

const About = () => {
  return (
    <> 
      <Breadcrumb title="About us" path="About us" />


      {/* About Section 1 */}
      <section className="py-16 container mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <div className="loader-line"></div>
          <h3 className="md:text-4xl text-2xl text-darktext font-semibold mb-4 mt-3">
            What is Rotiey?
          </h3>
          <p className="text-contentcolor leading-relaxed">
            Rotiey is a platform that connects people with fresh, homemade meals
            prepared by local home chefs. Whether you’re a student, working
            professional, or someone missing the taste of home, Rotiey delivers
            freshly-made rotis, theplas, and more right to your doorstep. We
            ensure hygiene, affordability, and the authentic flavor of
            traditional Indian kitchens.
          </p>
        </div>
        <div>
          <img
            src={aboutImg1}
            alt="about rotiey"
            className="md:px-16"
          />
        </div>
      </section>

      {/* About Section 2 */}
      <section className="py-16 container mx-auto px-4 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <img
            src={aboutImg2}
            alt="delivery"
            className="md:px-16"
          />
        </div>
        <div>
          <div className="loader-line"></div>
          <h3 className="md:text-4xl text-2xl text-darktext font-semibold mb-4 mt-3">
            Made With Love, Delivered With Care
          </h3>
          <p className="text-contentcolor leading-relaxed">
            Our mission is to empower local cooks by giving them a way to share
            their talent and earn from home. At the same time, customers benefit
            from healthy, home-cooked food without the hassle of cooking. With
            easy ordering, reliable delivery, and genuine taste, Rotiey brings
            the comfort of “Ghar Ka Khana” to your busy lifestyle.
          </p>
        </div>
      </section>

      <ServiceSection />
      <div className="mb-20">
        <DownloadAppBanner />
      </div>
    </>
  );
};

export default About;
